<template>
  <VLayout :title="$t('services.title')">
    <vue-element-loading :active="loading" />
    <b-row class="d-flex justify-content-between" v-if="!loading">
      <b-col
        class="category p-3"
        v-for="(service, index) in services"
        :key="index"
        cols="12"
        md="3"
      >
        <router-link :to="service.to" class="router-service">
          <b-card footer-tag="footer" class="clickable homecard bd-highlight">
            <div class="imgcontainer mb-0" style="--aspect-ratio:1/1;">
              <img
                :src="service.image"
                :alt="service.name"
                class="card-img"
              />
            </div>
            <p
              class="text-center align-middle m-0 text-truncate card-text text-uppercase"
              slot="footer"
            >{{ service.name }}</p>
          </b-card>
        </router-link>
      </b-col>
    </b-row>
  </VLayout>
</template>


<script>
import { mapActions } from "vuex";
import VLayout from "@/layouts/Default";

export default {
  components: {
    VLayout,
  },

  data() {
    return {
      loading: false,
      services: [
        {
          name: this.$t("services.medicines_import"),
          image: require("@/static/services/import.png"),
          to: {
            name: "importmedicineshome",
          },
        },
        // {
        //   name: this.$t("services.laboratory_research"),
        //   image: require("@/static/services/laboratory.png"),
        //   to: {
        //     name: "service-page",
        //     params: {
        //       serviceId: "laboratory",
        //     },
        //   },
        // },
        // {
        //   name: this.$t("services.optics"),
        //   image: require("@/static/services/optics.png"),
        //   to: {
        //     name: "service-page",
        //     params: {
        //       serviceId: "optics",
        //     },
        //   },
        // },
        // {
        //   name: this.$t("services.nursing"),
        //   image: require("@/static/services/nursing.png"),
        //   to: {
        //     name: "service-page",
        //     params: {
        //       serviceId: "nursing",
        //     },
        //   },
        // },
      ],
    };
  },
  mounted() {
    this.loading = true;
    this.REQUEST_INTERNATIONAL_TRADE_CONFIG().then(
      res => {
        this.loading = false;
        if (!res.data.active) {
          this.$router.push({
            name: "service-page",
          });
        }
      },
      () => {
        // con 404 también llegamos aquí
        this.$router.push({
          name: "service-page",
        });
        this.loading = false;
      }
    );
  },
  methods: {
    ...mapActions({
      REQUEST_INTERNATIONAL_TRADE_CONFIG:
        "organization/REQUEST_INTERNATIONAL_TRADE_CONFIG",
    }),
  },
  fallbackI18n: {
    messages: {
      und: {
        services: {
          title: "Services",
          breadcrumb: "Services",
          medicines_import: "Medicines Import",
          laboratory_research: "Laboratory Research",
          optics: "Optics",
          nursing: "Nursing",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.card-body {
  overflow: hidden;
  padding: 0rem;
}

.card-img {
  max-width: 100%;
  object-fit: cover;
  transition: all 0.3s;
}

.card-img:hover {
  transform: scale(1.1);
}

.card-text {
  text-decoration: none;
  color: $corp-color1;
  font-weight: bold;
}

.card-footer {
  background-color: $gray-200;
}

.router-service {
  text-decoration: none;
}
</style>

